import { render, staticRenderFns } from "./guida.vue?vue&type=template&id=3739be99&scoped=true"
import script from "./guida.vue?vue&type=script&lang=ts"
export * from "./guida.vue?vue&type=script&lang=ts"
import style0 from "./guida.vue?vue&type=style&index=0&id=3739be99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3739be99",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchWrapper: require('/usr/src/nuxt-app/components/core/SearchWrapper.vue').default,StaticTheBreadcrumbs: require('/usr/src/nuxt-app/components/static/TheBreadcrumbs.vue').default,ShowGallerySpecialInstagram: require('/usr/src/nuxt-app/components/show/gallery/SpecialInstagram.vue').default})
